package org.hs_soft.runmynesto.domain.model.login

enum class LoginStateEnum
{
    SIGN_IN,
    VERIFY_SIGN_IN_CODE,
    FORGET_PASSWORD_SEND_CODE,
    RESET_PASSWORD,
}